import { CustomRequestsOptions } from '@cutr/constants/windows/windows-configurations.ts';

import { ConfigurationTextArea } from '../inputs/ConfigurationTextArea';
import { CustomRequestConfigurationComponent } from '.';

const CustomRequestConfig = () => (
  <ConfigurationTextArea
    configurationKey="customRequest"
    dispatchAction="SET_CUSTOM_REQUESTS"
  />
);

const config: CustomRequestConfigurationComponent<'customRequest'> = {
  key: 'customRequest',
  input: <CustomRequestConfig />,
  display: (value: CustomRequestsOptions['customRequest']) => (
    <span>{value}</span>
  ),
};

export default config;
